import React from 'react';
import PropTypes from 'prop-types';
import { Designer } from 'apps/find-designers/propTypes';
import { DisplayName } from '@99designs/common/components/DisplayName';
import DesignerBrandingExtras from 'apps/find-designers/components/Listing/DesignerBrandingExtras';

const DesignerBranding = ({ designer, profileUrl, isContact, workRelationshipDescriptions }) => (
    <div className="designer-branding">
        <div className="designer-branding__details">
            <div className="designer-branding__details__name">
                <DisplayName
                    user={{ name: designer.name, profileUrl }}
                    variations={['non-attribution']}
                />
            </div>
            <span className="designer-branding__details__extras">
                <DesignerBrandingExtras
                    level={designer.level}
                    isContact={isContact}
                    workRelationshipDescriptions={workRelationshipDescriptions}
                />
            </span>
        </div>
    </div>
);

DesignerBranding.propTypes = {
    designer: Designer.isRequired,
    profileUrl: PropTypes.string.isRequired,
    isContact: PropTypes.bool.isRequired,
    workRelationshipDescriptions: PropTypes.array.isRequired,
};

export default DesignerBranding;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Listing/DesignerBranding.jsx